import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  statusList: [],
  addData: {},
  sorted: [],
  PurchaseNotesTypes: [],
};

const slice = createSlice({
  name: 'PurchaseNotes',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET PurchaseNotesManagement
    getAllPurchaseNotesTypesSuccess(state, action) {
      state.PurchaseNotesTypes = action.payload.data;
    },
    // GET PurchaseNotesManagement
    getPurchaseNotesSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET PurchaseNotesManagement
    getPurchaseNotesStatusSuccess(state, action) {
      state.statusList = action.payload.data;
    },

    addOrUpdatePurchaseNotes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllPurchaseNotesTypes() {
  return async () => {
    try {
      const response = await get(`allPurchaseNotesTypes`);
      if (response.status) {
        dispatch(slice.actions.getAllPurchaseNotesTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPurchaseNotes() {
  return async () => {
    try {
      const response = await get(`supplierPurchaseNote`);
      if (response.status) {
        dispatch(slice.actions.getPurchaseNotesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getPurchaseNoteStatus() {
  return async () => {
    try {
      const response = await get(`supplierPurchaseNoteStatus`);
      if (response.status) {
        dispatch(slice.actions.getPurchaseNotesStatusSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function insertPurchaseNotesPaymentNote(body) {
  return async () => {
    try {
      const response = await post(`PurchaseNoteLogMessage`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function uploadPurchaseNoteLinkedDocuments(body) {
  return async () => {
    try {
      const response = await post(`PurchaseNoteLinkedDocuments`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addPurchaseNotes(body) {
  return async () => {
    try {
      const response = await post(`supplierPurchaseNote`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addSupplierOrder(body) {
  return async () => {
    try {
      const response = await post(`SupplierOrder`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePurchaseNoteStatus(body) {
  return async () => {
    try {
      const response = await put(`PurchaseNoteStatus`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function updatePurchaseNotes(body) {
  return async () => {
    try {
      const response = await put(`PurchaseNotes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deletePurchaseNotes(body) {
  return async () => {
    try {
      const response = await deleteMethod(`PurchaseNotes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
